import { RadioButton, RadioButtonGroup, TextInput } from "@carbon/react";
import i18next from "../../../../i18n";
import { DELIVERY_TYPE, MaterialType } from "../../../../types";

type PeriodDateProps = {
  matToBid: any;
  handleSupplyPeriod: any;
};

const req = <span className="order-required"> *</span>;

export default function PeriodDate({
  matToBid,
  handleSupplyPeriod,
}: PeriodDateProps) {
  const termLabel =
    matToBid.type === MaterialType.SERVICES
      ? i18next.t("tenders.form.time")
      : i18next.t("tenders.form.term");

  return (
    <div className="order-period">
      <RadioButtonGroup
        name={`tender-period-${matToBid.id}`}
        legendText={<>{termLabel}{req}</>}
        valueSelected={matToBid.spot ?? ""}
        onChange={(value) =>
          handleSupplyPeriod(
            { target: { value } } as any,
            matToBid,
            DELIVERY_TYPE.SPOT
          )
        }
      >
        <RadioButton
          id={`spot-${matToBid.id}`}
          value={DELIVERY_TYPE.SPOT}
          labelText={i18next.t("tenders.form.spot")}
        />
        <RadioButton
          id={`period-${matToBid.id}`}
          value={DELIVERY_TYPE.PERIOD}
          labelText={i18next.t("tenders.form.period")}
        />
      </RadioButtonGroup>

      {matToBid.spot && (
        <div className="order-period__dates">
          {matToBid.spot === DELIVERY_TYPE.SPOT ? (
            <TextInput
              id={`startSupplyDate-${matToBid.id}`}
              type="date"
              labelText={<>{i18next.t("tenders.form.date")}{req}</>}
              value={matToBid.startSupplyDate ?? ""}
              onChange={(e) => handleSupplyPeriod(e, matToBid, "start")}
            />
          ) : (
            <>
              <TextInput
                id={`startSupplyDate-${matToBid.id}`}
                type="date"
                labelText={<>{i18next.t("tenders.form.from")}{req}</>}
                value={matToBid.startSupplyDate ?? ""}
                onChange={(e) => handleSupplyPeriod(e, matToBid, "start")}
              />
              <TextInput
                id={`endSupplyDate-${matToBid.id}`}
                type="date"
                labelText={<>{i18next.t("tenders.form.to")}{req}</>}
                min={matToBid.startSupplyDate}
                disabled={!matToBid.startSupplyDate}
                value={matToBid.endSupplyDate ?? ""}
                onChange={(e) => handleSupplyPeriod(e, matToBid, "end")}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
}
